import React from "react";
import LeadGenCtaBtn from "../../../features/lead-generation/LeadGenCtaBtn";

const ScholarshipAdmissions = () => {
  return (
    <div className="w-full bg-[#173CBA] text-white text-center py-5">
      <div className="container mx-auto flex flex-row items-center justify-center gap-4 px-6">
        <p className="text-[24px] font-normal leading-[36px]">
          Find out which colleges you qualify for - use our College Predictor today
        </p>
        <a
          href="/college-predictor"
          className="bg-green text-white py-2 px-4 rounded-md hover:bg-white hover:text-black transition-all whitespace-nowrap"
        >
          Click Here
        </a>
      </div>
    </div>
  );
};

export default ScholarshipAdmissions;
